<template>
  <div class="mb-5">
    <h5 class="cs-textstyle-section-heading mb-3">{{ cardTitle }}</h5>
    <div class="row">
      <member-card
        class="col-md-4 mb-4"
        v-for="(member, index) in displayMembers"
        :key="index"
        :member="member"
      ></member-card>
    </div>

    <see-more-button
      v-if="members.length > limit"
      :count="members.length - limit"
      @showMore="status => (showMore = status)"
    ></see-more-button>
  </div>
</template>
<script>
import MemberCard from '@/components/global/MemberCard';
import SeeMoreButton from '@/components/global/SeeMoreButton';

export default {
  name: 'member-list-card',

  components: {
    MemberCard,
    SeeMoreButton
  },

  props: ['members', 'cardTitle', 'limit'],

  data() {
    return {
      showMore: false
    };
  },

  computed: {
    displayMembers() {
      const limit = this.limit || 12;
      // Flattern where appropriate for nested entities
      let membersData =
        this.members &&
        this.members.map(member => {
          return member.member || member;
        });

      return this.showMore ? membersData : membersData.slice(0, limit);
    }
  }
};
</script>
